import { Pagination } from 'swiper/modules';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.ts';
import 'splitting/dist/splitting.css';
import 'splitting/dist/splitting-cells.css';
import gsap from 'gsap';

class BFGMasthead extends MainClass {
	private sliderInit = new Slider();
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}
	initCarouselOnMobile = ( element: HTMLElement ) => {
		if ( ! element || window.matchMedia( '(min-width:905px)' ).matches ) return;
		element.classList.add( 'swiper' );
		const sliderList = element.querySelector( '.slider-list' ) as HTMLElement;
		const sliderItems = Array.from( element.querySelectorAll( '.slider-item' ) ) as HTMLElement[];
		sliderList && sliderList.classList.add( 'swiper-wrapper' );
		sliderItems.slice( 1 ).forEach( ( item: HTMLElement ) => {
			item.classList.add( 'swiper-slide' );
		} );
		this.sliderInit.initCarousel( element, {
			slidesPerView: 1.2,
			spaceBetween: 16,
			loop: true,
			pagination: {
				el: '.raise-bfg-masthead .featured-image-swiper-pagination',
				clickable: true,
			},
			modules: [ Pagination ],
			breakpoints: {
				// when window width is >= 480px
				480: {
					slidesPerView: 1.5,
				},
				// when window width is >= 640px
				640: {
					slidesPerView: 2.2,
				},
			},
		} );
	};

	customHeightForImage = ( blocks: HTMLElement[] ) => {
		if ( blocks?.length ) {
			blocks.forEach( block => {
				const blockHeight = block.offsetHeight;
				const textBlock = block.querySelector( '.text-block' ) as HTMLElement;
				const textBlockHeight = textBlock?.offsetHeight;
				const image = block.querySelector( 'img' ) as HTMLElement;
				if ( image ) {
					image.style.height = `${ blockHeight - textBlockHeight }px`;
				}
			} );
		}
	};
	init() {
		const featuredSocialSlider = this.selector.querySelector( '.featured-social-slider' ) as HTMLElement;
		const popularSearchSwiper = this.selector.querySelector( '.popular-search-swiper' ) as HTMLElement;
		const searchWrapper = this.selector.querySelector( '.js-search-wrapper' ) as HTMLElement;
		const searchLine = this.selector.querySelector( '.js-boder-search-animation' ) as HTMLElement;
		const sandBlock = this.selector.querySelector( '#sand-block' ) as HTMLElement;
		const amberBlock = this.selector.querySelector( '#amber-block' ) as HTMLElement;
		const violetBlock = this.selector.querySelector( '#violet-block' ) as HTMLElement;
		const orangeBlock = this.selector.querySelector( '#orange-block' ) as HTMLElement;
		const sandImage = this.selector.querySelector( '#sand-image' ) as HTMLElement;
		const amberImage = this.selector.querySelector( '#amber-image' ) as HTMLElement;
		const violetImage = this.selector.querySelector( '#violet-image' ) as HTMLElement;
		const orangeImage = this.selector.querySelector( '#orange-image' ) as HTMLElement;
		const violetHeading = this.selector.querySelector( '#violet-heading' ) as HTMLElement;
		const orangeHeading = this.selector.querySelector( '#orange-heading' ) as HTMLElement;
		const amberHeading = this.selector.querySelector( '#amber-heading' ) as HTMLElement;
		const violetDescription = this.selector.querySelector( '#violet-description' ) as HTMLElement;
		const orangeDescription = this.selector.querySelector( '#orange-description' ) as HTMLElement;
		const amberDescription = this.selector.querySelector( '#amber-description' ) as HTMLElement;
		const bfgImageMobile = this.selector.querySelector( '.bfg-image-mobile' ) as HTMLElement;
		const paginationSlider = this.selector.querySelector( '.featured-image-swiper-pagination' ) as HTMLElement;
		const textOfImgaeBlockElements = [
			violetHeading,
			amberHeading,
			orangeHeading,
			violetDescription,
			amberDescription,
			orangeDescription,
		];
		const blocksToCustomHeight = [ sandBlock, amberBlock, violetBlock, orangeBlock ];
		const FIRST_STATE = 1;
		const SECOND_STATE = 2;
		const THIRD_STATE = 3;
		const TIMELINE_ANIMATION = gsap.timeline();
		const childBlock = Array.from(this.selector.querySelectorAll('.raise-bfg-masthead-headline-wrapper > *'))
		const textLabelMobile = Array.from(this.selector.querySelectorAll('.text-label-mobile'))
		if(childBlock.length > 0){
			TIMELINE_ANIMATION.fromTo(
				childBlock as HTMLElement[],
				{
					y: '100px',
					opacity: 0,
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.5,
					ease: 'power1.inOut',
					stagger:0.05
				},
				FIRST_STATE,
			);
		}
		if ( searchWrapper ) {
			TIMELINE_ANIMATION.fromTo(
				searchWrapper as HTMLElement,
				{
					opacity: 0,
				},
				{
					opacity: 1,
					duration: 0.5,
					ease: 'power1.inOut',
				},
				SECOND_STATE,
			);
		}
		if ( searchLine ) {
			TIMELINE_ANIMATION.fromTo(
				searchLine as HTMLElement,
				{
					width: 0,
				},
				{
					width: '100%',
					duration: 0.5,
					ease: 'power1.inOut',
				},
				SECOND_STATE,
			);
		}
		if ( window.matchMedia( '(min-width: 905px)' ).matches ) {
			if ( sandBlock ) {
				TIMELINE_ANIMATION.fromTo(
					sandBlock as HTMLElement,
					{
						x: '100%',
						opacity: 0,
					},
					{
						x: 0,
						opacity: 1,
						duration: 0.7,
						ease: 'power1.inOut',
					},
					FIRST_STATE,
				);
			}
			if ( violetBlock ) {
				TIMELINE_ANIMATION.fromTo(
					violetBlock as HTMLElement,
					{
						x: '-100%',
						opacity: 0,
					},
					{
						x: 0,
						opacity: 1,
						duration: 0.7,
						ease: 'power1.inOut',
					},
					FIRST_STATE,
				);
			}
			if ( orangeBlock ) {
				TIMELINE_ANIMATION.fromTo(
					orangeBlock as HTMLElement,
					{
						y: '100%',
						opacity: 0,
					},
					{
						y: 0,
						opacity: 1,
						duration: 0.7,
						ease: 'power1.inOut',
					},
					SECOND_STATE,
				);
			}
			if ( amberBlock ) {
				TIMELINE_ANIMATION.fromTo(
					amberBlock as HTMLElement,
					{
						y: '100%',
						opacity: 0,
					},
					{
						y: 0,
						opacity: 1,
						duration: 0.7,
						ease: 'power1.inOut',
					},
					SECOND_STATE,
				);
			}
		} else {
			if ( textLabelMobile && textLabelMobile.length > 0 ) {
				textLabelMobile.forEach( ( line, index ) => {
						TIMELINE_ANIMATION.fromTo(
							line as HTMLElement[],
							{
								x: '-100px',
								opacity: 0,
							},
							{
								opacity: 1,
								x: 0,
								duration: 0.5,
								ease: 'power1.inOut',
								delay: index * 0.1,
							},
							THIRD_STATE,
						);
					} );
			}

			if ( paginationSlider ) {
				TIMELINE_ANIMATION.fromTo(
					paginationSlider,
					{
						width: 0,
						opacity: 0,
					},
					{
						opacity: 1,
						width: '100%',
						duration: 0.5,
						ease: 'power1.inOut',
					},
					THIRD_STATE,
				);
			}

			if ( bfgImageMobile ) {
				TIMELINE_ANIMATION.fromTo(
					bfgImageMobile,
					{
						x: '100px',
						opacity: 0,
					},
					{
						opacity: 1,
						x: 0,
						duration: 0.5,
						ease: 'power1.inOut',
					},
					THIRD_STATE,
				);
			}

			if ( featuredSocialSlider ) {
				TIMELINE_ANIMATION.fromTo(
					featuredSocialSlider as HTMLElement,
					{
						x: '50%',
						opacity: 0,
					},
					{
						x: 0,
						opacity: 1,
						duration: 0.7,
						ease: 'power1.inOut',
					},
					THIRD_STATE,
				);
			}
		}
		if ( sandImage ) {
			TIMELINE_ANIMATION.fromTo(
				sandImage as HTMLElement,
				{
					y: '100%',
					opacity: 0,
				},
				{
					y: 0,
					opacity: 1,
					duration: 0.7,
					ease: 'power1.inOut',
				},
				SECOND_STATE,
			);
		}
		if ( violetImage ) {
			TIMELINE_ANIMATION.fromTo(
				violetImage as HTMLElement,
				{
					scale: 1.2,
					opacity: 0,
				},
				{
					scale: 1,
					opacity: 1,
					duration: 0.7,
					ease: 'power1.inOut',
				},
				SECOND_STATE,
			);
		}
		if ( orangeImage ) {
			TIMELINE_ANIMATION.fromTo(
				orangeImage as HTMLElement,
				{
					scale: 1.2,
					opacity: 0,
				},
				{
					scale: 1,
					opacity: 1,
					duration: 0.7,
					ease: 'power1.inOut',
				},
				THIRD_STATE,
			);
		}
		if ( amberImage ) {
			TIMELINE_ANIMATION.fromTo(
				amberImage as HTMLElement,
				{
					scale: 1.2,
					opacity: 0,
				},
				{
					scale: 1,
					opacity: 1,
					duration: 0.7,
					ease: 'power1.inOut',
				},
				THIRD_STATE,
			);
		}
		if ( textOfImgaeBlockElements?.length ) {
			textOfImgaeBlockElements.forEach( element => {
				if ( element ) {
					TIMELINE_ANIMATION.fromTo(
						element as HTMLElement,
						{
							y: '100%',
							opacity: 0,
						},
						{
							y: 0,
							opacity: 1,
							duration: 0.7,
							ease: 'power1.inOut',
						},
						element.id === 'violet-heading' || element.id === 'violet-description'
							? SECOND_STATE
							: THIRD_STATE,
					);
				}
			} );
		}
		this.initCarouselOnMobile( featuredSocialSlider );
		this.customHeightForImage( blocksToCustomHeight );

		if ( popularSearchSwiper ) {
			this.sliderInit.initCarousel( popularSearchSwiper, {
				slidesPerView: 'auto',
				spaceBetween: 0,
			} );
		}
	}
}

export default BFGMasthead;
